"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const classNames = require("classnames");
const numeral = require("numeral");
const _isEmpty = require("lodash.isempty");
const react_1 = require("react");
const _1 = require("./../");
const models_1 = require("./models");
class DatagridHeader extends react_1.Component {
    constructor(props) {
        super(props);
        this.renderOptions = () => {
            const options = this.props.searchPropertyOptions;
            return options.map(o => React.createElement("option", { key: o.value, value: o.value }, o.text));
        };
        this.renderViewModeButtons = () => {
            const { viewMode, viewModeButtons } = this.props;
            return viewModeButtons
                .filter(button => button.type !== viewMode)
                .map(button => (React.createElement(_1.DropdownItem, { key: button.type, className: "btn btn-link btn-icon btn-square", onClick: this.handleViewModeChange(button.type) },
                React.createElement(_1.Icon, { name: button.icon }))));
        };
        this.handleViewModeChange = (viewMode) => () => {
            this.props.onChangeViewMode(viewMode);
            this.toggleViewModeMenu();
        };
        this.handleSearchTermChange = (e) => {
            this.props.onTypeSearchTerm(e.target.value);
        };
        this.handleRemoveIconClick = () => {
            this.props.onTypeSearchTerm('');
            this.searchInput.focus();
        };
        this.handleSearchIconClick = () => {
            this.searchInput.focus();
        };
        this.getDefaultValueForSelect = () => {
            const options = this.props.searchPropertyOptions;
            return options.filter(o => o.selected)[0].value;
        };
        this.toggleHeaderRightContainer = () => {
            this.setState({ showSearchInput: !this.state.showSearchInput });
        };
        this.toggleViewModeMenu = () => {
            this.setState({ viewModeMenuActive: !this.state.viewModeMenuActive });
        };
        const { noSearchBarCollapse, viewMode } = props;
        this.state = {
            showSearchInput: noSearchBarCollapse,
            viewModeMenuActive: false,
        };
    }
    render() {
        const { hideSearchByField, hideToggleFilterButton, hideViewModeButton, hideTotalInfo, mainButton, noSearchBarCollapse, searchInputPlaceholder, searchPropertyOptions, searchTerm, total, viewMode, onTypeSearchTerm, onChangeSearchProperty, onChangeViewMode, onClickToggleFiltersButton } = this.props;
        const { showSearchInput, viewModeMenuActive } = this.state;
        return (React.createElement("div", { className: "bkn-datagrid-header" },
            React.createElement("div", { className: "bkn-datagrid-header-left" },
                this.renderMainButton(),
                React.createElement("div", { className: classNames('input-search', { searching: !_isEmpty(searchTerm) }) },
                    React.createElement("div", { className: "icon" },
                        React.createElement(_1.Icon, { className: "search", name: "search", onClick: this.handleSearchIconClick }),
                        React.createElement(_1.Icon, { className: "close", name: "close", onClick: this.handleRemoveIconClick })),
                    React.createElement("input", { className: "form-control", placeholder: searchInputPlaceholder, ref: instance => this.searchInput = instance, type: "search", value: searchTerm, onChange: this.handleSearchTermChange })),
                (!hideSearchByField && searchPropertyOptions.length !== 0) && (React.createElement("div", { className: "search-property-select hidden-sm-down" },
                    React.createElement("small", { className: "text-uppercase" }, "By"),
                    React.createElement("select", { className: "form-control-sm custom-select", defaultValue: this.getDefaultValueForSelect(), onChange: onChangeSearchProperty }, this.renderOptions()))),
                !noSearchBarCollapse && (React.createElement("button", { className: "btn btn-link btn-icon btn-square btn-sm hidden-lg-up", onClick: this.toggleHeaderRightContainer },
                    React.createElement(_1.Icon, { name: "more" })))),
            React.createElement("div", { className: classNames('bkn-datagrid-header-right', {
                    'sm-active': !showSearchInput,
                    'no-main-button': !mainButton,
                }) },
                !hideTotalInfo && (React.createElement("small", { className: "text-uppercase hidden-xs-down" },
                    numeral(total).format('0,0'),
                    " found")),
                React.createElement("button", { className: "btn btn-link btn-icon btn-square hidden-lg-up", onClick: this.toggleHeaderRightContainer },
                    React.createElement(_1.Icon, { name: "search" })),
                !hideViewModeButton && (React.createElement(_1.Dropdown, { className: "view-mode-menu", isOpen: viewModeMenuActive, toggle: this.toggleViewModeMenu },
                    React.createElement(_1.DropdownToggle, { className: "btn-link btn-icon btn-square", id: "view-mode-menu", "data-toggle": "dropdown", "aria-haspopup": true, "aria-expanded": false },
                        viewMode === models_1.ViewMode.cards && React.createElement(_1.Icon, { name: "view_module" }),
                        viewMode === models_1.ViewMode.table && React.createElement(_1.Icon, { name: "view_list" })),
                    React.createElement(_1.DropdownMenu, { right: true, "aria-labelledby": "view-mode-menu" }, this.renderViewModeButtons()))),
                !hideToggleFilterButton && (React.createElement("button", { className: "btn btn-link btn-icon btn-square", onClick: onClickToggleFiltersButton },
                    React.createElement(_1.Icon, { name: "filter_list" }))))));
    }
    renderMainButton() {
        const { mainButton } = this.props;
        if (!mainButton) {
            return null;
        }
        const { children } = mainButton, otherMainButtonProps = __rest(mainButton, ["children"]);
        return (React.createElement("a", Object.assign({ className: "btn btn-primary btn-link btn-icon btn-square btn-list-action" }, otherMainButtonProps),
            React.createElement(_1.Icon, { name: "add" })));
    }
}
DatagridHeader.defaultProps = {
    viewModeButtons: [
        { type: models_1.ViewMode.cards, icon: 'view_module' },
        { type: models_1.ViewMode.table, icon: 'view_list' },
    ],
};
exports.DatagridHeader = DatagridHeader;



//////////////////
// WEBPACK FOOTER
// ./src/components/Datagrid/DatagridHeader.tsx
// module id = 246
// module chunks = 0